export default { VIEW_ALL: 'viewAll' };
